export const texts = {
    linkText: "קראו עוד >"
}